@if (loginForm$ | async; as form) {
  <form
    [ngrxFormState]="form"
    (submit)="onSubmit(form)"
    >
    <div>
      @if ((userMustResetPassword$ | async) === false) {
        <div>
          <div class="mb-3">
            <ideapa-text-field
              id="input-email"
              [label]="'Email'"
              [showHint]="false"
              [ngrxFormControlState]="form.controls.username"
              [errors]="form.controls.username.errors | ngrxFormsErr"
              [shouldShowError]="form.controls.username.isInvalid && form.controls.username.isSubmitted"
              >
            </ideapa-text-field>
          </div>
          <div class="mb-3">
            <ideapa-text-field
              id="input-password"
              [label]="'Password'"
              [showHint]="false"
              [controlType]="'password'"
              [ngrxFormControlState]="form.controls.password"
              [errors]="form.controls.password.errors | ngrxFormsErr"
              [shouldShowError]="form.controls.password.isInvalid && form.controls.password.isSubmitted"
              >
            </ideapa-text-field>
          </div>
        </div>
      }
      @if (userMustResetPassword$ | async) {
        <div>
          <div class="login-ideapa mat-title">Scegli la tua password</div>
          <div>
            <ideapa-text-field
              [label]="'Password'"
              [controlType]="'password'"
              [ngrxFormControlState]="form.controls.newPassword"
              [errors]="form.controls.newPassword.errors | ngrxFormsErr"
              [shouldShowError]="form.controls.newPassword.isSubmitted"
              >
            </ideapa-text-field>
          </div>
          <div>
            <ideapa-text-field
              [label]="'Conferma Password'"
              [controlType]="'password'"
              [ngrxFormControlState]="form.controls.confirmPassword"
              [errors]="form.controls.confirmPassword.errors | ngrxFormsErr"
              [shouldShowError]="form.controls.confirmPassword.isSubmitted"
              >
            </ideapa-text-field>
          </div>
          <div translate class="password-hint">
            La password deve essere lunga almeno 8 caratteri.<br />
            Deve contenere maiuscole e minuscole.<br />
            Deve contenere almeno un numero.<br />
            Deve contenere almeno un carattere speciale (!&#64;#$%^&*_-).
          </div>
          <!-- <div translate class="mt-3 privacy-policy">
          Facendo login, acconsento a
          <a href="https://www.iubenda.com/privacy-policy/" target="_blank"
            >Privacy Policy</a
            >
            e
            <a href="https://www.iubenda.com/termini-e-condizioni/" target="_blank"
              >Termini e condizioni</a
              >.
            </div> -->
          </div>
        }
        <div class="mb-4">
          <div class="d-flex">
            <div>
              <ideapa-check-field [ngrxFormControlState]="form.controls.rememberMe">
              </ideapa-check-field>
            </div>
            <div>Memorizzare la sessione?</div>
          </div>
        </div>
        <div id="" class="mt-3 text-end">
          <ideapa-button
            id="button-login"
            type="submit"
            [cssClasses]="'btn-primary'"
            [text]="'Login'"
          ></ideapa-button>
          <ideapa-button
            class="ms-2 d-none"
            [cssClasses]="'btn-primary'"
            [text]="'Login Azure Active Directory'"
            (clicked)="aadLogin(form)"
          ></ideapa-button>
        </div>
        @if ((userMustResetPassword$ | async) === false) {
          <div
            class="mt-2 text-end"
            >
            <a [routerLink]="['/auth/forgot-password']" translate class="forgot-link"
              >Password dimenticata?</a
              >
            </div>
          }
          <div id="error-message" class="login-error text-danger text-end mt-3">
            {{ loginError$ | ngrxPush }}
          </div>
          <div class="footer-verion">IdeaSoftware © {{ version }}</div>
        </div>
      </form>
    }
